import { Product, ProductCategory, ContactInfo, ValueProp } from '../types';
import { ALL_BROTHER_RICOH_PRODUCTS } from './mockProductsBrotherRicoh';
import { ALL_CANON_IR1022_PRODUCTS } from './mockProductsCanonIR1022';

// ============================================
// DTK S.r.l. - Complete Site Data
// Prodotti arricchiti con campi DB legacy (dbo_Articoli)
// ============================================

export const BRANDS: string[] = [
  "AGFA", "APPLE", "BROTHER", "CANON", "COPYSTAR", "DATAPRODUCTS",
  "DELL", "DEVELOP", "DUPLO", "EPSON", "FUJITSU", "GENICOM",
  "GESTETNER", "HITACHI", "HP", "IBM", "INFOTEC", "KODAK",
  "KONICA", "KYOCERA MITA", "LANIER", "LEXMARK", "MANNESMANN TALLY",
  "MINOLTA", "NASHUATEC", "NEC", "OCE", "OKI", "OLIVETTI",
  "OLYMPIA", "PANASONIC", "PHILIPS", "PUNTI METALLICI", "REX ROTARY",
  "RICOH", "RISOGRAPH", "SAGEM", "SAMSUNG", "SANYO", "SELEX",
  "SHARP", "TECPANTUM", "TELECOM", "TEXAS", "TOSHIBA",
  "TRIUMPH ADLER", "TTR", "UTAX", "XEROX"
];

export const PRODUCT_CATEGORIES: ProductCategory[] = [
  {
    id: "toner",
    title: "Toner",
    subtitle: "Compatibili e originali per laser",
    description: "I toner DTK sono costruiti con materiali che rispettano gli standard OEM e soddisfano le aspettative dei clienti più esigenti. Garantiscono stampe nitide e precise, sia nel testo che nelle immagini.",
    icon: "Droplets",
    count: "2.500+",
    features: ["Standard OEM", "Test approfonditi", "Risparmio garantito", "Ideali per noleggio"]
  },
  {
    id: "laser-inkjet",
    title: "Laser & Inkjet",
    subtitle: "Cartucce ricondizionate e rigenerate",
    description: "Le cartucce DTK per Laser e Inkjet offrono il massimo sia in termini di qualità di stampa che di durata. Coprono l'intera gamma di stampanti e MFP, con risparmio fino all'80%.",
    icon: "Printer",
    count: "3.000+",
    features: ["Risparmio fino all'80%", "Gamma completa", "Mono e colori", "Modelli attuali e obsoleti"]
  },
  {
    id: "opc-drum",
    title: "OPC Drum",
    subtitle: "Tamburi con standard OEM",
    description: "I tamburi OPC DTK provengono dai migliori costruttori al mondo. Disponibili per la maggior parte delle copiatrici e stampanti multifunzione, con elevato standard di qualità.",
    icon: "Disc",
    count: "1.200+",
    features: ["Migliori produttori", "Qualità OEM", "Prezzi competitivi", "Riduzione tempi intervento"]
  },
  {
    id: "ricambi",
    title: "Ricambi",
    subtitle: "Rulli, fusori, ingranaggi e componenti",
    description: "DTK dispone di una vastissima gamma di ricambi per copiatrici e stampanti multifunzione, caratterizzati da altissimi livelli di precisione e cura nella fabbricazione.",
    icon: "Wrench",
    count: "1.300+",
    features: ["Vastissima gamma", "Alta precisione", "Produttori selezionati", "Sempre a magazzino"]
  },
  {
    id: "prodotti-pulizia",
    title: "Attrezzature tecniche",
    subtitle: "Spray, panni e soluzioni per la manutenzione",
    description: "Linea completa di prodotti dedicati alla pulizia e manutenzione di stampanti, copiatrici e periferiche d'ufficio. Soluzioni professionali per garantire efficienza e durata delle macchine.",
    icon: "Sparkles",
    count: "150+",
    features: ["Sicuri sui materiali", "Formulazioni dedicate", "Pratica e veloce", "Disponibili a magazzino"]
  }
];

// ============================================
// SAMPLE_PRODUCTS — Arricchiti con tutti i campi DB
// Campi aggiunti: dtkCodice, idFamiglia, famiglia, idCategoriaMerceologica,
// categoriaMerceologica, idMarca, idColore, coloreDescrizione, idUdm, unitaDiMisura,
// minimoVendibile, confezione, richiedeAbbinamento, isKit, originale, pesante,
// pesoLordo, pesoNetto, lunghezza, larghezza, altezza, classeSconto, codiceBarcode,
// dataInserimento, dataUltimaModifica
// ============================================

export const SAMPLE_PRODUCTS: Product[] = [
  // ============ TONER ============

  {
    sku: "TN-2420", brand: "BROTHER", category: "toner",
    title: "Toner Compatibile Brother TN-2420",
    compatibility: "HL-L2310D, HL-L2350DW, HL-L2370DN, MFC-L2710DW, MFC-L2750DW",
    type: "Compatibile", yield: "3.000 pagine", color: "Nero",
    // === DB legacy fields ===
    dtkCodice: "2867825", idFamiglia: 5, famiglia: "Toner Laser Mono",
    idCategoriaMerceologica: 114, categoriaMerceologica: "Toner Laser Mono",
    idMarca: 3, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.620, pesoNetto: 0.510, lunghezza: 28.5, larghezza: 11.0, altezza: 9.0,
    classeSconto: "BR2420", dataInserimento: "2021-11-12", dataUltimaModifica: "2024-01-15",
  },
  {
    sku: "TN-247BK", brand: "BROTHER", category: "toner",
    title: "Toner Brother TN-247BK Nero",
    compatibility: "HL-L3210CW, HL-L3230CDW, MFC-L3710CW, MFC-L3750CDW, MFC-L3770CDW",
    type: "Compatibile", yield: "3.000 pagine", color: "Nero",
    dtkCodice: "1419610", idFamiglia: 6, famiglia: "Toner Laser Colore",
    idCategoriaMerceologica: 113, categoriaMerceologica: "Toner Laser Colore",
    idMarca: 3, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.720, pesoNetto: 0.590, lunghezza: 29.0, larghezza: 11.5, altezza: 9.5,
    classeSconto: "BR247K", dataInserimento: "2021-11-12", dataUltimaModifica: "2024-01-15",
  },
  {
    sku: "TN-247C", brand: "BROTHER", category: "toner",
    title: "Toner Brother TN-247C Ciano",
    compatibility: "HL-L3210CW, HL-L3230CDW, MFC-L3710CW, MFC-L3770CDW",
    type: "Compatibile", yield: "2.300 pagine", color: "Ciano",
    dtkCodice: "5614226", idFamiglia: 6, famiglia: "Toner Laser Colore",
    idCategoriaMerceologica: 113, categoriaMerceologica: "Toner Laser Colore",
    idMarca: 3, idColore: 2, coloreDescrizione: "Ciano",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.650, pesoNetto: 0.520, lunghezza: 29.0, larghezza: 11.5, altezza: 9.5,
    classeSconto: "BR247C", dataInserimento: "2021-11-12", dataUltimaModifica: "2024-01-15",
  },
  {
    sku: "TN-247M", brand: "BROTHER", category: "toner",
    title: "Toner Brother TN-247M Magenta",
    compatibility: "HL-L3210CW, HL-L3230CDW, MFC-L3710CW, MFC-L3770CDW",
    type: "Compatibile", yield: "2.300 pagine", color: "Magenta",
    dtkCodice: "5108603", idFamiglia: 6, famiglia: "Toner Laser Colore",
    idCategoriaMerceologica: 113, categoriaMerceologica: "Toner Laser Colore",
    idMarca: 3, idColore: 3, coloreDescrizione: "Magenta",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.650, pesoNetto: 0.520, lunghezza: 29.0, larghezza: 11.5, altezza: 9.5,
    classeSconto: "BR247M", dataInserimento: "2021-11-12", dataUltimaModifica: "2024-01-15",
  },
  {
    sku: "TN-247Y", brand: "BROTHER", category: "toner",
    title: "Toner Brother TN-247Y Giallo",
    compatibility: "HL-L3210CW, HL-L3230CDW, MFC-L3710CW, MFC-L3770CDW",
    type: "Compatibile", yield: "2.300 pagine", color: "Giallo",
    dtkCodice: "4744854", idFamiglia: 6, famiglia: "Toner Laser Colore",
    idCategoriaMerceologica: 113, categoriaMerceologica: "Toner Laser Colore",
    idMarca: 3, idColore: 4, coloreDescrizione: "Giallo",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.640, pesoNetto: 0.510, lunghezza: 29.0, larghezza: 11.5, altezza: 9.5,
    classeSconto: "BR247Y", dataInserimento: "2021-11-12", dataUltimaModifica: "2024-01-15",
  },
  {
    sku: "TN-3480", brand: "BROTHER", category: "toner",
    title: "Toner Brother TN-3480 Alta Capacità",
    compatibility: "HL-L5000D, HL-L5100DN, HL-L5200DW, MFC-L5700DN, MFC-L5750DW, MFC-L6900DW",
    type: "Compatibile", yield: "8.000 pagine", color: "Nero",
    dtkCodice: "3341057", idFamiglia: 5, famiglia: "Toner Laser Mono",
    idCategoriaMerceologica: 114, categoriaMerceologica: "Toner Laser Mono",
    idMarca: 3, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.980, pesoNetto: 0.840, lunghezza: 33.0, larghezza: 11.0, altezza: 9.5,
    classeSconto: "BR3480", dataInserimento: "2022-03-01", dataUltimaModifica: "2024-02-20",
    idTipologiaNovita: 1, novita: "Nuovo Arrivo", dataScadenzaNovita: "2024-06-30",
  },
  {
    sku: "CF259A", brand: "HP", category: "toner",
    title: "Toner Compatibile HP 59A CF259A",
    compatibility: "LaserJet Pro M304a, M404d, M404dn, M404dw, M404n, MFP M428dw, M428fdn, M428fdw",
    type: "Compatibile", yield: "3.000 pagine", color: "Nero",
    dtkCodice: "2719583", idFamiglia: 5, famiglia: "Toner Laser Mono",
    idCategoriaMerceologica: 114, categoriaMerceologica: "Toner Laser Mono",
    idMarca: 15, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.680, pesoNetto: 0.550, lunghezza: 25.0, larghezza: 8.5, altezza: 11.5,
    classeSconto: "HP59A", codiceBarcode: "0889894046988",
    dataInserimento: "2021-11-12", dataUltimaModifica: "2024-03-10",
  },
  {
    sku: "CF259X", brand: "HP", category: "toner",
    title: "Toner HP 59X CF259X Alta Capacità",
    compatibility: "LaserJet Pro M304a, M404d, M404dn, M404dw, MFP M428dw, M428fdn, M428fdw",
    type: "Compatibile", yield: "10.000 pagine", color: "Nero",
    dtkCodice: "2458591", idFamiglia: 21, famiglia: "Toner Compatibile Alta Cap",
    idCategoriaMerceologica: 114, categoriaMerceologica: "Toner Laser Mono",
    idMarca: 15, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.850, pesoNetto: 0.720, lunghezza: 25.5, larghezza: 8.5, altezza: 11.5,
    classeSconto: "HP59X", codiceBarcode: "0889894046896",
    dataInserimento: "2021-11-12", dataUltimaModifica: "2024-03-10",
  },
  {
    sku: "W2030A", brand: "HP", category: "toner",
    title: "Toner HP 415A W2030A Nero",
    compatibility: "Color LaserJet Pro M454dw, M454dn, MFP M479dw, M479fdn, M479fdw",
    type: "Compatibile", yield: "2.400 pagine", color: "Nero",
    dtkCodice: "8078673", idFamiglia: 6, famiglia: "Toner Laser Colore",
    idCategoriaMerceologica: 113, categoriaMerceologica: "Toner Laser Colore",
    idMarca: 15, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.750, pesoNetto: 0.610, lunghezza: 26.0, larghezza: 9.0, altezza: 12.0,
    classeSconto: "HP415K", codiceBarcode: "0193905431612",
    dataInserimento: "2022-01-10", dataUltimaModifica: "2024-03-10",
  },
  {
    sku: "W2031A", brand: "HP", category: "toner",
    title: "Toner HP 415A W2031A Ciano",
    compatibility: "Color LaserJet Pro M454dw, M454dn, MFP M479dw, M479fdn, M479fdw",
    type: "Compatibile", yield: "2.100 pagine", color: "Ciano",
    dtkCodice: "1533224", idFamiglia: 6, famiglia: "Toner Laser Colore",
    idCategoriaMerceologica: 113, categoriaMerceologica: "Toner Laser Colore",
    idMarca: 15, idColore: 2, coloreDescrizione: "Ciano",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.710, pesoNetto: 0.580, lunghezza: 26.0, larghezza: 9.0, altezza: 12.0,
    classeSconto: "HP415C", codiceBarcode: "0193905431629",
    dataInserimento: "2022-01-10", dataUltimaModifica: "2024-03-10",
  },
  {
    sku: "CE285A", brand: "HP", category: "toner",
    title: "Toner HP 85A CE285A",
    compatibility: "LaserJet Pro P1102, P1102W, M1132, M1210, M1212nf, M1214nfh, M1216nfh, M1217nfw",
    type: "Compatibile", yield: "1.600 pagine", color: "Nero",
    dtkCodice: "1499914", idFamiglia: 5, famiglia: "Toner Laser Mono",
    idCategoriaMerceologica: 114, categoriaMerceologica: "Toner Laser Mono",
    idMarca: 15, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.580, pesoNetto: 0.450, lunghezza: 22.0, larghezza: 7.5, altezza: 9.5,
    classeSconto: "HP85A", codiceBarcode: "0884420387534",
    dataInserimento: "2021-11-12", dataUltimaModifica: "2023-12-01",
  },
  {
    sku: "TK-1170", brand: "KYOCERA MITA", category: "toner",
    title: "Toner Compatibile Kyocera TK-1170",
    compatibility: "ECOSYS M2040dn, M2540dn, M2540dw, M2640idw",
    type: "Compatibile", yield: "7.200 pagine", color: "Nero",
    dtkCodice: "2571945", idFamiglia: 5, famiglia: "Toner Laser Mono",
    idCategoriaMerceologica: 114, categoriaMerceologica: "Toner Laser Mono",
    idMarca: 20, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.890, pesoNetto: 0.740, lunghezza: 30.5, larghezza: 9.0, altezza: 10.5,
    classeSconto: "KY1170", codiceBarcode: "0632983028827",
    dataInserimento: "2021-11-12", dataUltimaModifica: "2024-01-20",
  },
  {
    sku: "TK-5240K", brand: "KYOCERA MITA", category: "toner",
    title: "Toner Kyocera TK-5240K Nero",
    compatibility: "ECOSYS M5526cdn, M5526cdw, P5026cdn, P5026cdw",
    type: "Compatibile", yield: "4.000 pagine", color: "Nero",
    dtkCodice: "4668136", idFamiglia: 6, famiglia: "Toner Laser Colore",
    idCategoriaMerceologica: 113, categoriaMerceologica: "Toner Laser Colore",
    idMarca: 20, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.780, pesoNetto: 0.640, lunghezza: 28.0, larghezza: 9.5, altezza: 10.0,
    classeSconto: "KY5240", dataInserimento: "2022-06-01", dataUltimaModifica: "2024-02-15",
  },
  {
    sku: "TK-5240C", brand: "KYOCERA MITA", category: "toner",
    title: "Toner Kyocera TK-5240C Ciano",
    compatibility: "ECOSYS M5526cdn, M5526cdw, P5026cdn, P5026cdw",
    type: "Compatibile", yield: "3.000 pagine", color: "Ciano",
    dtkCodice: "4903402", idFamiglia: 6, famiglia: "Toner Laser Colore",
    idCategoriaMerceologica: 113, categoriaMerceologica: "Toner Laser Colore",
    idMarca: 20, idColore: 2, coloreDescrizione: "Ciano",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.730, pesoNetto: 0.600, lunghezza: 28.0, larghezza: 9.5, altezza: 10.0,
    classeSconto: "KY5240", dataInserimento: "2022-06-01", dataUltimaModifica: "2024-02-15",
  },
  {
    sku: "CLT-K404S", brand: "SAMSUNG", category: "toner",
    title: "Toner Samsung CLT-K404S Nero",
    compatibility: "Xpress SL-C430, SL-C430W, SL-C480, SL-C480W, SL-C480FN, SL-C480FW",
    type: "Compatibile", yield: "1.500 pagine", color: "Nero",
    dtkCodice: "9478454", idFamiglia: 6, famiglia: "Toner Laser Colore",
    idCategoriaMerceologica: 113, categoriaMerceologica: "Toner Laser Colore",
    idMarca: 38, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.420, pesoNetto: 0.330, lunghezza: 20.5, larghezza: 8.0, altezza: 9.0,
    classeSconto: "SAM404", dataInserimento: "2022-01-20", dataUltimaModifica: "2024-01-10",
  },
  {
    sku: "CLT-K506L", brand: "SAMSUNG", category: "toner",
    title: "Toner Samsung CLT-K506L Nero HC",
    compatibility: "CLP-680DW, CLP-680ND, CLX-6260FD, CLX-6260FR, CLX-6260FW, CLX-6260ND",
    type: "Compatibile", yield: "6.000 pagine", color: "Nero",
    dtkCodice: "1445199", idFamiglia: 6, famiglia: "Toner Laser Colore",
    idCategoriaMerceologica: 113, categoriaMerceologica: "Toner Laser Colore",
    idMarca: 38, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.680, pesoNetto: 0.550, lunghezza: 23.0, larghezza: 9.5, altezza: 10.5,
    classeSconto: "SAM506", dataInserimento: "2021-11-12", dataUltimaModifica: "2023-10-15",
  },
  {
    sku: "C-EXV49", brand: "CANON", category: "toner",
    title: "Toner Canon C-EXV49 Nero",
    compatibility: "imageRUNNER ADVANCE C3320, C3320i, C3325i, C3330i, C3520i, C3525i, C3530i",
    type: "Compatibile", yield: "36.000 pagine", color: "Nero",
    dtkCodice: "4335942", idFamiglia: 6, famiglia: "Toner Laser Colore",
    idCategoriaMerceologica: 113, categoriaMerceologica: "Toner Laser Colore",
    idMarca: 4, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: true, isKit: false, originale: false, pesante: true,
    pesoLordo: 1.850, pesoNetto: 1.580, lunghezza: 38.5, larghezza: 12.0, altezza: 14.5,
    classeSconto: "CA49", codiceBarcode: "4549292072808",
    dataInserimento: "2021-11-12", dataUltimaModifica: "2024-04-01",
  },
  {
    sku: "054H BK", brand: "CANON", category: "toner",
    title: "Toner Canon 054H Nero Alta Capacità",
    compatibility: "i-SENSYS LBP621Cw, LBP623Cdw, MF641Cw, MF643Cdw, MF645Cx",
    type: "Compatibile", yield: "3.100 pagine", color: "Nero",
    dtkCodice: "8038374", idFamiglia: 6, famiglia: "Toner Laser Colore",
    idCategoriaMerceologica: 113, categoriaMerceologica: "Toner Laser Colore",
    idMarca: 4, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.650, pesoNetto: 0.520, lunghezza: 27.0, larghezza: 9.5, altezza: 11.0,
    classeSconto: "CA054H", codiceBarcode: "4549292131956",
    dataInserimento: "2022-05-10", dataUltimaModifica: "2024-04-01",
  },
  {
    sku: "MP C2503", brand: "RICOH", category: "toner",
    title: "Toner Ricoh MP C2503 Set CMYK",
    compatibility: "MP C2003, MP C2003SP, MP C2503, MP C2503SP, MP C2004, MP C2504",
    type: "Compatibile", yield: "15.000 pagine", color: "Set CMYK",
    dtkCodice: "4698379", idFamiglia: 6, famiglia: "Toner Laser Colore",
    idCategoriaMerceologica: 113, categoriaMerceologica: "Toner Laser Colore",
    idMarca: 35, idColore: 5, coloreDescrizione: "Set CMYK",
    idUdm: 8, unitaDiMisura: "SET",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: true, isKit: true, originale: false, pesante: true,
    pesoLordo: 3.200, pesoNetto: 2.680, lunghezza: 35.0, larghezza: 14.0, altezza: 28.0,
    classeSconto: "RIC2503", dataInserimento: "2021-11-12", dataUltimaModifica: "2024-02-28",
  },
  {
    sku: "MP C3003", brand: "RICOH", category: "toner",
    title: "Toner Ricoh MP C3003 Nero",
    compatibility: "MP C3003, MP C3003SP, MP C3503, MP C3503SP, MP C4503, MP C5503, MP C6003",
    type: "Compatibile", yield: "29.500 pagine", color: "Nero",
    dtkCodice: "8536477", idFamiglia: 6, famiglia: "Toner Laser Colore",
    idCategoriaMerceologica: 113, categoriaMerceologica: "Toner Laser Colore",
    idMarca: 35, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: true, isKit: false, originale: false, pesante: true,
    pesoLordo: 2.450, pesoNetto: 2.100, lunghezza: 42.0, larghezza: 10.5, altezza: 13.5,
    classeSconto: "RIC3003", dataInserimento: "2022-01-15", dataUltimaModifica: "2024-02-28",
  },
  {
    sku: "106R03480", brand: "XEROX", category: "toner",
    title: "Toner Xerox 106R03480 Nero",
    compatibility: "Phaser 6510, Phaser 6510DN, Phaser 6510DNI, WorkCentre 6515, WC 6515DN",
    type: "Compatibile", yield: "5.500 pagine", color: "Nero",
    dtkCodice: "5667265", idFamiglia: 6, famiglia: "Toner Laser Colore",
    idCategoriaMerceologica: 113, categoriaMerceologica: "Toner Laser Colore",
    idMarca: 49, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.820, pesoNetto: 0.670, lunghezza: 30.5, larghezza: 10.5, altezza: 11.5,
    classeSconto: "XER6510", codiceBarcode: "0095205888751",
    dataInserimento: "2022-02-01", dataUltimaModifica: "2024-03-05",
  },
  {
    sku: "106R03692", brand: "XEROX", category: "toner",
    title: "Toner Xerox 106R03692 Ciano HC",
    compatibility: "Phaser 6510, Phaser 6510DN, WorkCentre 6515, WorkCentre 6515DN",
    type: "Compatibile", yield: "4.300 pagine", color: "Ciano",
    dtkCodice: "1109031", idFamiglia: 6, famiglia: "Toner Laser Colore",
    idCategoriaMerceologica: 113, categoriaMerceologica: "Toner Laser Colore",
    idMarca: 49, idColore: 2, coloreDescrizione: "Ciano",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.780, pesoNetto: 0.640, lunghezza: 30.5, larghezza: 10.5, altezza: 11.5,
    classeSconto: "XER6510C", codiceBarcode: "0095205888768",
    dataInserimento: "2022-02-01", dataUltimaModifica: "2024-03-05",
  },
  {
    sku: "50F2H00", brand: "LEXMARK", category: "toner",
    title: "Toner Lexmark 502H Alta Capacità",
    compatibility: "MS310d, MS310dn, MS312dn, MS410d, MS410dn, MS415dn, MS510dn, MS610dn",
    type: "Compatibile", yield: "5.000 pagine", color: "Nero",
    dtkCodice: "3678638", idFamiglia: 5, famiglia: "Toner Laser Mono",
    idCategoriaMerceologica: 114, categoriaMerceologica: "Toner Laser Mono",
    idMarca: 22, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.720, pesoNetto: 0.590, lunghezza: 27.5, larghezza: 9.5, altezza: 11.0,
    classeSconto: "LEX502H", dataInserimento: "2022-03-15", dataUltimaModifica: "2023-11-20",
  },
  {
    sku: "B2236", brand: "LEXMARK", category: "toner",
    title: "Toner Lexmark B2236 Nero",
    compatibility: "B2236dw, MB2236adw, MB2236adwe",
    type: "Compatibile", yield: "3.000 pagine", color: "Nero",
    dtkCodice: "8090293", idFamiglia: 5, famiglia: "Toner Laser Mono",
    idCategoriaMerceologica: 114, categoriaMerceologica: "Toner Laser Mono",
    idMarca: 22, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.580, pesoNetto: 0.460, lunghezza: 23.0, larghezza: 8.0, altezza: 9.5,
    classeSconto: "LEXB223", dataInserimento: "2023-01-10", dataUltimaModifica: "2024-01-15",
  },
  {
    sku: "46508712", brand: "OKI", category: "toner",
    title: "Toner OKI C332 Nero",
    compatibility: "C332dn, MC363dn",
    type: "Compatibile", yield: "3.500 pagine", color: "Nero",
    dtkCodice: "6708456", idFamiglia: 6, famiglia: "Toner Laser Colore",
    idCategoriaMerceologica: 113, categoriaMerceologica: "Toner Laser Colore",
    idMarca: 28, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.680, pesoNetto: 0.550, lunghezza: 27.0, larghezza: 8.5, altezza: 11.5,
    classeSconto: "OKI332", dataInserimento: "2022-04-01", dataUltimaModifica: "2023-09-10",
  },
  {
    sku: "T-FC25EK", brand: "TOSHIBA", category: "toner",
    title: "Toner Toshiba T-FC25E-K Nero",
    compatibility: "e-STUDIO 2040C, 2540C, 3040C, 3540C, 4540C",
    type: "Compatibile", yield: "34.200 pagine", color: "Nero",
    dtkCodice: "5661907", idFamiglia: 6, famiglia: "Toner Laser Colore",
    idCategoriaMerceologica: 113, categoriaMerceologica: "Toner Laser Colore",
    idMarca: 45, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: true, isKit: false, originale: false, pesante: true,
    pesoLordo: 2.100, pesoNetto: 1.780, lunghezza: 40.0, larghezza: 11.0, altezza: 13.0,
    classeSconto: "TOS25EK", dataInserimento: "2021-11-12", dataUltimaModifica: "2023-12-05",
  },
  {
    sku: "B0946", brand: "OLIVETTI", category: "toner",
    title: "Toner Olivetti B0946 Nero",
    compatibility: "d-Color MF2400, d-Color MF3000, d-Color MF2400plus",
    type: "Compatibile", yield: "12.000 pagine", color: "Nero",
    dtkCodice: "3608513", idFamiglia: 6, famiglia: "Toner Laser Colore",
    idCategoriaMerceologica: 113, categoriaMerceologica: "Toner Laser Colore",
    idMarca: 29, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: true, isKit: false, originale: false, pesante: false,
    pesoLordo: 1.100, pesoNetto: 0.920, lunghezza: 33.5, larghezza: 10.5, altezza: 11.0,
    classeSconto: "OLI946", dataInserimento: "2021-11-12", dataUltimaModifica: "2023-08-20",
  },

  // ============ LASER & INKJET ============

  {
    sku: "LC-3213", brand: "BROTHER", category: "laser-inkjet",
    title: "Cartuccia Brother LC-3213 Set CMYK",
    compatibility: "DCP-J572DW, DCP-J772DW, MFC-J491DW, MFC-J497DW, MFC-J890DW, MFC-J895DW",
    type: "Compatibile", yield: "400 pagine", color: "Set CMYK",
    dtkCodice: "4612365", idFamiglia: 7, famiglia: "Cartucce InkJet",
    idCategoriaMerceologica: 112, categoriaMerceologica: "Cartucce InkJet",
    idMarca: 3, idColore: 5, coloreDescrizione: "Set CMYK",
    idUdm: 8, unitaDiMisura: "SET",
    minimoVendibile: 1, confezione: 4,
    richiedeAbbinamento: false, isKit: true, originale: false, pesante: false,
    pesoLordo: 0.280, pesoNetto: 0.210, lunghezza: 18.0, larghezza: 12.5, altezza: 7.5,
    classeSconto: "BR3213", dataInserimento: "2022-01-15", dataUltimaModifica: "2024-02-10",
  },
  {
    sku: "LC-3233", brand: "BROTHER", category: "laser-inkjet",
    title: "Cartuccia Brother LC-3233 Set",
    compatibility: "DCP-J1100DW, MFC-J1300DW",
    type: "Compatibile", yield: "550 pagine", color: "Set CMYK",
    dtkCodice: "6647119", idFamiglia: 7, famiglia: "Cartucce InkJet",
    idCategoriaMerceologica: 112, categoriaMerceologica: "Cartucce InkJet",
    idMarca: 3, idColore: 5, coloreDescrizione: "Set CMYK",
    idUdm: 8, unitaDiMisura: "SET",
    minimoVendibile: 1, confezione: 4,
    richiedeAbbinamento: false, isKit: true, originale: false, pesante: false,
    pesoLordo: 0.320, pesoNetto: 0.240, lunghezza: 20.0, larghezza: 13.0, altezza: 7.5,
    classeSconto: "BR3233", dataInserimento: "2022-06-01", dataUltimaModifica: "2024-01-20",
  },
  {
    sku: "LC-1240BK", brand: "BROTHER", category: "laser-inkjet",
    title: "Cartuccia Brother LC-1240BK Nero",
    compatibility: "MFC-J430W, MFC-J432W, MFC-J625DW, MFC-J825DW, MFC-J835DW",
    type: "Compatibile", yield: "600 pagine", color: "Nero",
    dtkCodice: "2714803", idFamiglia: 7, famiglia: "Cartucce InkJet",
    idCategoriaMerceologica: 112, categoriaMerceologica: "Cartucce InkJet",
    idMarca: 3, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.090, pesoNetto: 0.065, lunghezza: 12.5, larghezza: 4.5, altezza: 9.0,
    classeSconto: "BR1240", dataInserimento: "2021-11-12", dataUltimaModifica: "2023-06-15",
  },
  {
    sku: "PGI-580/CLI-581", brand: "CANON", category: "laser-inkjet",
    title: "Set Cartucce Canon PGI-580/CLI-581 XXL",
    compatibility: "PIXMA TR7550, TR8550, TR8650, TS6150, TS6350, TS8150, TS8250, TS9150",
    type: "Compatibile", yield: "400 pagine", color: "Set 5 colori",
    dtkCodice: "2556017", idFamiglia: 7, famiglia: "Cartucce InkJet",
    idCategoriaMerceologica: 112, categoriaMerceologica: "Cartucce InkJet",
    idMarca: 4, idColore: 6, coloreDescrizione: "Set 5 colori",
    idUdm: 8, unitaDiMisura: "SET",
    minimoVendibile: 1, confezione: 5,
    richiedeAbbinamento: false, isKit: true, originale: false, pesante: false,
    pesoLordo: 0.350, pesoNetto: 0.260, lunghezza: 22.0, larghezza: 14.0, altezza: 6.5,
    classeSconto: "CA580", dataInserimento: "2022-03-01", dataUltimaModifica: "2024-03-15",
  },
  {
    sku: "PG-545XL/CL-546XL", brand: "CANON", category: "laser-inkjet",
    title: "Multipack Canon PG-545XL/CL-546XL",
    compatibility: "PIXMA MG2450, MG2550, MG2555S, MG3050, MG3051, TS3150, TS3350, TR4550",
    type: "Compatibile", yield: "400/300 pagine", color: "Nero + Colore",
    dtkCodice: "7374122", idFamiglia: 7, famiglia: "Cartucce InkJet",
    idCategoriaMerceologica: 112, categoriaMerceologica: "Cartucce InkJet",
    idMarca: 4, idColore: 7, coloreDescrizione: "Nero + Colore",
    idUdm: 8, unitaDiMisura: "SET",
    minimoVendibile: 1, confezione: 2,
    richiedeAbbinamento: false, isKit: true, originale: false, pesante: false,
    pesoLordo: 0.190, pesoNetto: 0.140, lunghezza: 17.0, larghezza: 11.0, altezza: 6.0,
    classeSconto: "CA545", dataInserimento: "2021-11-12", dataUltimaModifica: "2024-01-10",
  },
  {
    sku: "PG-540XL", brand: "CANON", category: "laser-inkjet",
    title: "Cartuccia Canon PG-540XL Nero",
    compatibility: "PIXMA MG2150, MG2250, MG3150, MG3250, MG3550, MG4150, MX375, MX435",
    type: "Compatibile", yield: "600 pagine", color: "Nero",
    dtkCodice: "2622631", idFamiglia: 7, famiglia: "Cartucce InkJet",
    idCategoriaMerceologica: 112, categoriaMerceologica: "Cartucce InkJet",
    idMarca: 4, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.080, pesoNetto: 0.060, lunghezza: 12.0, larghezza: 4.5, altezza: 8.5,
    classeSconto: "CA540", dataInserimento: "2021-11-12", dataUltimaModifica: "2023-08-10",
  },
  {
    sku: "T0715", brand: "EPSON", category: "laser-inkjet",
    title: "Multipack Epson T0715 CMYK",
    compatibility: "Stylus SX200, SX205, SX210, SX215, SX400, SX405, SX415, DX7400, DX8400",
    type: "Compatibile", yield: "250 pagine", color: "Set CMYK",
    dtkCodice: "7022674", idFamiglia: 7, famiglia: "Cartucce InkJet",
    idCategoriaMerceologica: 112, categoriaMerceologica: "Cartucce InkJet",
    idMarca: 10, idColore: 5, coloreDescrizione: "Set CMYK",
    idUdm: 8, unitaDiMisura: "SET",
    minimoVendibile: 1, confezione: 4,
    richiedeAbbinamento: false, isKit: true, originale: false, pesante: false,
    pesoLordo: 0.240, pesoNetto: 0.170, lunghezza: 16.5, larghezza: 11.0, altezza: 6.5,
    classeSconto: "EP715", dataInserimento: "2021-11-12", dataUltimaModifica: "2023-05-20",
  },
  {
    sku: "T1285", brand: "EPSON", category: "laser-inkjet",
    title: "Multipack Epson T1285 Set",
    compatibility: "Stylus SX125, SX230, SX235W, SX420W, SX425W, SX430W, SX435W, SX445W",
    type: "Compatibile", yield: "170 pagine", color: "Set CMYK",
    dtkCodice: "6770619", idFamiglia: 7, famiglia: "Cartucce InkJet",
    idCategoriaMerceologica: 112, categoriaMerceologica: "Cartucce InkJet",
    idMarca: 10, idColore: 5, coloreDescrizione: "Set CMYK",
    idUdm: 8, unitaDiMisura: "SET",
    minimoVendibile: 1, confezione: 4,
    richiedeAbbinamento: false, isKit: true, originale: false, pesante: false,
    pesoLordo: 0.200, pesoNetto: 0.150, lunghezza: 16.0, larghezza: 10.5, altezza: 6.5,
    classeSconto: "EP1285", dataInserimento: "2021-11-12", dataUltimaModifica: "2023-05-20",
  },
  {
    sku: "T2711", brand: "EPSON", category: "laser-inkjet",
    title: "Cartuccia Epson 27XL T2711 Nero",
    compatibility: "WorkForce WF-3620DWF, WF-3640DTWF, WF-7110DTW, WF-7210DTW, WF-7610DWF",
    type: "Compatibile", yield: "1.100 pagine", color: "Nero",
    dtkCodice: "5437923", idFamiglia: 7, famiglia: "Cartucce InkJet",
    idCategoriaMerceologica: 112, categoriaMerceologica: "Cartucce InkJet",
    idMarca: 10, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.110, pesoNetto: 0.080, lunghezza: 14.0, larghezza: 5.0, altezza: 9.5,
    classeSconto: "EP27XL", dataInserimento: "2022-02-15", dataUltimaModifica: "2023-10-10",
  },
  {
    sku: "T405XL", brand: "EPSON", category: "laser-inkjet",
    title: "Set Epson 405XL T405XL CMYK",
    compatibility: "WorkForce Pro WF-3820DWF, WF-3825DWF, WF-4820DWF, WF-4825DWF, WF-7830DTWF",
    type: "Compatibile", yield: "1.100 pagine", color: "Set CMYK",
    dtkCodice: "1728977", idFamiglia: 7, famiglia: "Cartucce InkJet",
    idCategoriaMerceologica: 112, categoriaMerceologica: "Cartucce InkJet",
    idMarca: 10, idColore: 5, coloreDescrizione: "Set CMYK",
    idUdm: 8, unitaDiMisura: "SET",
    minimoVendibile: 1, confezione: 4,
    richiedeAbbinamento: false, isKit: true, originale: false, pesante: false,
    pesoLordo: 0.380, pesoNetto: 0.280, lunghezza: 20.5, larghezza: 13.5, altezza: 7.0,
    classeSconto: "EP405XL", dataInserimento: "2022-09-01", dataUltimaModifica: "2024-02-20",
    idTipologiaNovita: 1, novita: "Nuovo Arrivo", dataScadenzaNovita: "2024-06-30",
  },
  {
    sku: "HP 953XL", brand: "HP", category: "laser-inkjet",
    title: "Set HP 953XL Alta Capacità CMYK",
    compatibility: "OfficeJet Pro 7720, 7730, 7740, 8210, 8218, 8710, 8720, 8725, 8730, 8740",
    type: "Compatibile", yield: "2.000/1.600 pagine", color: "Set CMYK",
    dtkCodice: "8707870", idFamiglia: 7, famiglia: "Cartucce InkJet",
    idCategoriaMerceologica: 112, categoriaMerceologica: "Cartucce InkJet",
    idMarca: 15, idColore: 5, coloreDescrizione: "Set CMYK",
    idUdm: 8, unitaDiMisura: "SET",
    minimoVendibile: 1, confezione: 4,
    richiedeAbbinamento: false, isKit: true, originale: false, pesante: false,
    pesoLordo: 0.450, pesoNetto: 0.340, lunghezza: 22.5, larghezza: 14.5, altezza: 7.0,
    classeSconto: "HP953", dataInserimento: "2022-03-15", dataUltimaModifica: "2024-03-10",
  },
  {
    sku: "HP 963XL", brand: "HP", category: "laser-inkjet",
    title: "Set HP 963XL Alta Capacità",
    compatibility: "OfficeJet Pro 9010, 9012, 9013, 9014, 9015, 9016, 9019, 9020, 9022, 9025",
    type: "Compatibile", yield: "2.000/1.600 pagine", color: "Set CMYK",
    dtkCodice: "9996414", idFamiglia: 7, famiglia: "Cartucce InkJet",
    idCategoriaMerceologica: 112, categoriaMerceologica: "Cartucce InkJet",
    idMarca: 15, idColore: 5, coloreDescrizione: "Set CMYK",
    idUdm: 8, unitaDiMisura: "SET",
    minimoVendibile: 1, confezione: 4,
    richiedeAbbinamento: false, isKit: true, originale: false, pesante: false,
    pesoLordo: 0.460, pesoNetto: 0.350, lunghezza: 23.0, larghezza: 14.5, altezza: 7.0,
    classeSconto: "HP963", dataInserimento: "2022-09-01", dataUltimaModifica: "2024-03-10",
    idTipologiaNovita: 2, novita: "In Promozione", dataScadenzaNovita: "2024-03-31",
  },
  {
    sku: "HP 305XL", brand: "HP", category: "laser-inkjet",
    title: "Multipack HP 305XL Nero+Colore",
    compatibility: "DeskJet 2710, 2720, 2723, 2724, 4120, ENVY 6010, 6020, 6030",
    type: "Compatibile", yield: "240/200 pagine", color: "Nero + Colore",
    dtkCodice: "3094235", idFamiglia: 7, famiglia: "Cartucce InkJet",
    idCategoriaMerceologica: 112, categoriaMerceologica: "Cartucce InkJet",
    idMarca: 15, idColore: 7, coloreDescrizione: "Nero + Colore",
    idUdm: 8, unitaDiMisura: "SET",
    minimoVendibile: 1, confezione: 2,
    richiedeAbbinamento: false, isKit: true, originale: false, pesante: false,
    pesoLordo: 0.185, pesoNetto: 0.135, lunghezza: 17.5, larghezza: 11.0, altezza: 5.5,
    classeSconto: "HP305", dataInserimento: "2022-06-15", dataUltimaModifica: "2024-01-25",
  },
  {
    sku: "HP 302XL", brand: "HP", category: "laser-inkjet",
    title: "Set HP 302XL Nero+Colore",
    compatibility: "DeskJet 1110, 2130, 3630, 3632, ENVY 4520, 4524, OfficeJet 3830, 3834",
    type: "Compatibile", yield: "480/330 pagine", color: "Nero + Colore",
    dtkCodice: "7350753", idFamiglia: 7, famiglia: "Cartucce InkJet",
    idCategoriaMerceologica: 112, categoriaMerceologica: "Cartucce InkJet",
    idMarca: 15, idColore: 7, coloreDescrizione: "Nero + Colore",
    idUdm: 8, unitaDiMisura: "SET",
    minimoVendibile: 1, confezione: 2,
    richiedeAbbinamento: false, isKit: true, originale: false, pesante: false,
    pesoLordo: 0.195, pesoNetto: 0.145, lunghezza: 18.0, larghezza: 11.0, altezza: 5.5,
    classeSconto: "HP302", dataInserimento: "2021-11-12", dataUltimaModifica: "2024-01-25",
  },

  // ============ OPC DRUM ============

  {
    sku: "DR-2400", brand: "BROTHER", category: "opc-drum",
    title: "Tamburo Brother DR-2400",
    compatibility: "HL-L2310D, HL-L2350DW, HL-L2370DN, MFC-L2710DW, MFC-L2750DW, DCP-L2510D",
    type: "Compatibile", yield: "12.000 pagine", color: "-",
    dtkCodice: "2322047", idFamiglia: 4, famiglia: "Tamburi OPC",
    idCategoriaMerceologica: 115, categoriaMerceologica: "Tamburi OPC",
    idMarca: 3, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.850, pesoNetto: 0.720, lunghezza: 32.5, larghezza: 12.0, altezza: 12.5,
    classeSconto: "BR2400DR", codiceBarcode: "0012502625551",
    dataInserimento: "2021-11-12", dataUltimaModifica: "2024-01-15",
  },
  {
    sku: "DR-3400", brand: "BROTHER", category: "opc-drum",
    title: "Tamburo Brother DR-3400",
    compatibility: "HL-L5000D, HL-L5100DN, HL-L5200DW, MFC-L5700DN, MFC-L5750DW, MFC-L6900DW",
    type: "Compatibile", yield: "30.000 pagine", color: "-",
    dtkCodice: "5918715", idFamiglia: 4, famiglia: "Tamburi OPC",
    idCategoriaMerceologica: 115, categoriaMerceologica: "Tamburi OPC",
    idMarca: 3, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 1.350, pesoNetto: 1.150, lunghezza: 38.0, larghezza: 12.5, altezza: 13.5,
    classeSconto: "BR3400DR", codiceBarcode: "0012502627579",
    dataInserimento: "2022-03-01", dataUltimaModifica: "2024-02-10",
    idTipologiaNovita: 1, novita: "Nuovo Arrivo", dataScadenzaNovita: "2024-06-30",
  },
  {
    sku: "DR-243CL", brand: "BROTHER", category: "opc-drum",
    title: "Tamburo Brother DR-243CL",
    compatibility: "HL-L3210CW, HL-L3230CDW, HL-L3270CDW, MFC-L3710CW, MFC-L3750CDW, MFC-L3770CDW",
    type: "Compatibile", yield: "18.000 pagine", color: "-",
    dtkCodice: "7067228", idFamiglia: 4, famiglia: "Tamburi OPC",
    idCategoriaMerceologica: 115, categoriaMerceologica: "Tamburi OPC",
    idMarca: 3, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 1.120, pesoNetto: 0.950, lunghezza: 35.5, larghezza: 12.5, altezza: 13.0,
    classeSconto: "BR243DR", dataInserimento: "2022-01-20", dataUltimaModifica: "2024-01-15",
  },
  {
    sku: "CF232A", brand: "HP", category: "opc-drum",
    title: "Tamburo HP 32A CF232A",
    compatibility: "LaserJet Pro M203d, M203dn, M203dw, MFP M227fdn, M227fdw, M227sdn, M230sdn",
    type: "Compatibile", yield: "23.000 pagine", color: "-",
    dtkCodice: "4226067", idFamiglia: 4, famiglia: "Tamburi OPC",
    idCategoriaMerceologica: 115, categoriaMerceologica: "Tamburi OPC",
    idMarca: 15, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 1.050, pesoNetto: 0.890, lunghezza: 30.0, larghezza: 12.0, altezza: 13.0,
    classeSconto: "HP32A", codiceBarcode: "0889894545350",
    dataInserimento: "2021-11-12", dataUltimaModifica: "2024-03-10",
  },
  {
    sku: "CF219A", brand: "HP", category: "opc-drum",
    title: "Tamburo HP 19A CF219A",
    compatibility: "LaserJet Pro M102a, M102w, MFP M130a, M130fn, M130fw, M130nw",
    type: "Compatibile", yield: "12.000 pagine", color: "-",
    dtkCodice: "2166941", idFamiglia: 4, famiglia: "Tamburi OPC",
    idCategoriaMerceologica: 115, categoriaMerceologica: "Tamburi OPC",
    idMarca: 15, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.680, pesoNetto: 0.570, lunghezza: 24.5, larghezza: 11.5, altezza: 11.5,
    classeSconto: "HP19A", dataInserimento: "2022-04-10", dataUltimaModifica: "2024-01-10",
  },
  {
    sku: "DK-1150", brand: "KYOCERA MITA", category: "opc-drum",
    title: "Tamburo Kyocera DK-1150",
    compatibility: "ECOSYS M2040dn, M2135dn, M2540dn, M2635dn, M2640idw, P2040dn, P2235dn",
    type: "Compatibile", yield: "100.000 pagine", color: "-",
    dtkCodice: "1768805", idFamiglia: 4, famiglia: "Tamburi OPC",
    idCategoriaMerceologica: 115, categoriaMerceologica: "Tamburi OPC",
    idMarca: 20, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 1.480, pesoNetto: 1.250, lunghezza: 38.0, larghezza: 10.5, altezza: 13.0,
    classeSconto: "KY1150DR", dataInserimento: "2021-11-12", dataUltimaModifica: "2024-02-15",
  },
  {
    sku: "DK-5140", brand: "KYOCERA MITA", category: "opc-drum",
    title: "Tamburo Kyocera DK-5140",
    compatibility: "ECOSYS M6035cidn, M6535cidn, P6035cdn, P6035cdnx",
    type: "Compatibile", yield: "200.000 pagine", color: "-",
    dtkCodice: "4823498", idFamiglia: 4, famiglia: "Tamburi OPC",
    idCategoriaMerceologica: 115, categoriaMerceologica: "Tamburi OPC",
    idMarca: 20, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: true, isKit: false, originale: false, pesante: true,
    pesoLordo: 3.200, pesoNetto: 2.750, lunghezza: 45.0, larghezza: 12.0, altezza: 14.0,
    classeSconto: "KY5140DR", dataInserimento: "2022-04-01", dataUltimaModifica: "2024-02-15",
  },
  {
    sku: "DR-512K", brand: "KONICA", category: "opc-drum",
    title: "Tamburo Konica Minolta DR-512K Nero",
    compatibility: "bizhub C224, C224e, C284, C284e, C364, C364e, C454, C454e, C554, C554e",
    type: "Compatibile", yield: "120.000 pagine", color: "Nero",
    dtkCodice: "5855124", idFamiglia: 4, famiglia: "Tamburi OPC",
    idCategoriaMerceologica: 115, categoriaMerceologica: "Tamburi OPC",
    idMarca: 19, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: true, isKit: false, originale: false, pesante: true,
    pesoLordo: 2.850, pesoNetto: 2.420, lunghezza: 43.5, larghezza: 11.0, altezza: 14.5,
    classeSconto: "KON512", dataInserimento: "2022-05-20", dataUltimaModifica: "2024-01-10",
  },
  {
    sku: "D089-2251", brand: "RICOH", category: "opc-drum",
    title: "Tamburo Ricoh MP C3003/C3503",
    compatibility: "MP C3003, MP C3003SP, MP C3503, MP C3503SP, MP C4503, MP C5503, MP C6003",
    type: "Compatibile", yield: "400.000 pagine", color: "-",
    dtkCodice: "2338687", idFamiglia: 4, famiglia: "Tamburi OPC",
    idCategoriaMerceologica: 115, categoriaMerceologica: "Tamburi OPC",
    idMarca: 35, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: true, isKit: false, originale: false, pesante: true,
    pesoLordo: 4.500, pesoNetto: 3.900, lunghezza: 50.0, larghezza: 13.0, altezza: 17.5,
    classeSconto: "RIC3003DR", dataInserimento: "2022-01-15", dataUltimaModifica: "2024-02-28",
  },
  {
    sku: "101R00555", brand: "XEROX", category: "opc-drum",
    title: "Tamburo Xerox 101R00555",
    compatibility: "Phaser 3330, WorkCentre 3335, WorkCentre 3345",
    type: "Compatibile", yield: "30.000 pagine", color: "-",
    dtkCodice: "4905582", idFamiglia: 4, famiglia: "Tamburi OPC",
    idCategoriaMerceologica: 115, categoriaMerceologica: "Tamburi OPC",
    idMarca: 49, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.980, pesoNetto: 0.830, lunghezza: 31.5, larghezza: 12.0, altezza: 12.5,
    classeSconto: "XER3330DR", dataInserimento: "2022-02-01", dataUltimaModifica: "2024-03-05",
  },
  {
    sku: "44574302", brand: "OKI", category: "opc-drum",
    title: "Tamburo OKI B411/B431",
    compatibility: "B411d, B411dn, B431d, B431dn, MB461, MB471, MB481, MB491",
    type: "Compatibile", yield: "25.000 pagine", color: "-",
    dtkCodice: "2694522", idFamiglia: 4, famiglia: "Tamburi OPC",
    idCategoriaMerceologica: 115, categoriaMerceologica: "Tamburi OPC",
    idMarca: 28, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.920, pesoNetto: 0.780, lunghezza: 30.0, larghezza: 11.5, altezza: 12.0,
    classeSconto: "OKI411DR", dataInserimento: "2022-04-01", dataUltimaModifica: "2023-09-10",
  },
  {
    sku: "OD-FC49", brand: "TOSHIBA", category: "opc-drum",
    title: "Tamburo Toshiba OD-FC49",
    compatibility: "e-STUDIO 2040C, 2540C, 3040C, 3540C, 4540C",
    type: "Compatibile", yield: "75.000 pagine", color: "-",
    dtkCodice: "7377459", idFamiglia: 4, famiglia: "Tamburi OPC",
    idCategoriaMerceologica: 115, categoriaMerceologica: "Tamburi OPC",
    idMarca: 45, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: true, isKit: false, originale: false, pesante: true,
    pesoLordo: 3.800, pesoNetto: 3.200, lunghezza: 47.0, larghezza: 12.5, altezza: 15.5,
    classeSconto: "TOS49DR", dataInserimento: "2021-11-12", dataUltimaModifica: "2023-12-05",
  },

  // ============ RICAMBI ============
  // (FM2-5533-000 e FM4-8400-010 ora in mockProductsCanonIR1022.ts)

  {
    sku: "FC6-7083", brand: "CANON", category: "ricambi",
    title: "Rullo Presa Carta Canon",
    compatibility: "iR1018, iR1018J, iR1019, iR1019J, iR1022, iR1022A, iR1022F, iR1022i, iR1024",
    type: "Compatibile", yield: "-", color: "-",
    dtkCodice: "5663623", idFamiglia: 1, famiglia: "Alimentazione/Trasporto",
    idCategoriaMerceologica: 139, categoriaMerceologica: "Rulli Presa Carta",
    idMarca: 4, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 2, confezione: 1,
    richiedeAbbinamento: true, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.120, pesoNetto: 0.090, lunghezza: 12.0, larghezza: 6.5, altezza: 6.5,
    classeSconto: "CA-ROLL", dataInserimento: "2021-11-12", dataUltimaModifica: "2023-12-05",
  },
  {
    sku: "AE02-0207", brand: "RICOH", category: "ricambi",
    title: "Rullo Fusore Inferiore Ricoh",
    compatibility: "Aficio MP 4000, MP 4000B, MP 4001, MP 4001SP, MP 5000, MP 5000B, MP 5001",
    type: "Compatibile", yield: "-", color: "-",
    dtkCodice: "8606962", idFamiglia: 2, famiglia: "Gruppi Fusore",
    idCategoriaMerceologica: 150, categoriaMerceologica: "Rulli Fusore",
    idMarca: 35, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: true, isKit: false, originale: false, pesante: true,
    pesoLordo: 1.180, pesoNetto: 0.980, lunghezza: 36.0, larghezza: 7.5, altezza: 7.5,
    classeSconto: "RIC-FUSER", dataInserimento: "2021-11-12", dataUltimaModifica: "2023-10-20",
  },
  {
    sku: "AE01-1131", brand: "RICOH", category: "ricambi",
    title: "Rullo Fusore Superiore Ricoh",
    compatibility: "Aficio MP 2352, MP 2352SP, MP 2852, MP 2852SP, MP 3352, MP 3352SP",
    type: "Compatibile", yield: "-", color: "-",
    dtkCodice: "7120868", idFamiglia: 2, famiglia: "Gruppi Fusore",
    idCategoriaMerceologica: 150, categoriaMerceologica: "Rulli Fusore",
    idMarca: 35, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: true, isKit: false, originale: false, pesante: true,
    pesoLordo: 1.050, pesoNetto: 0.880, lunghezza: 34.5, larghezza: 7.5, altezza: 7.5,
    classeSconto: "RIC-FUSER", dataInserimento: "2022-02-10", dataUltimaModifica: "2023-10-20",
  },
  {
    sku: "D009-2836", brand: "RICOH", category: "ricambi",
    title: "Lama Pulizia Ricoh",
    compatibility: "MP C2800, MP C2800SPF, MP C3300, MP C3300AD, MP C4000, MP C5000",
    type: "Compatibile", yield: "-", color: "-",
    dtkCodice: "3728882", idFamiglia: 3, famiglia: "Lame Pulizia / Wiper",
    idCategoriaMerceologica: 118, categoriaMerceologica: "Lame e Wiper",
    idMarca: 35, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: true, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.180, pesoNetto: 0.130, lunghezza: 32.0, larghezza: 4.0, altezza: 5.0,
    classeSconto: "RIC-BLADE", dataInserimento: "2022-03-15", dataUltimaModifica: "2023-08-10",
  },
  {
    sku: "2F925050", brand: "KYOCERA MITA", category: "ricambi",
    title: "Rullo Fusore Kyocera",
    compatibility: "FS-1028MFP, FS-1128MFP, FS-1350DN, FS-1370DN",
    type: "Compatibile", yield: "-", color: "-",
    dtkCodice: "7210606", idFamiglia: 2, famiglia: "Gruppi Fusore",
    idCategoriaMerceologica: 150, categoriaMerceologica: "Rulli Fusore",
    idMarca: 20, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: true, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.780, pesoNetto: 0.650, lunghezza: 30.0, larghezza: 7.0, altezza: 7.0,
    classeSconto: "KY-FUSER", dataInserimento: "2022-01-20", dataUltimaModifica: "2024-01-10",
  },
  {
    sku: "302LV93010", brand: "KYOCERA MITA", category: "ricambi",
    title: "Rullo Presa Carta Kyocera",
    compatibility: "ECOSYS M2030dn, M2030dnPL, M2530dn, M2035dn, M2535dn, FS-1030MFP, FS-1130MFP",
    type: "Compatibile", yield: "-", color: "-",
    dtkCodice: "6960453", idFamiglia: 1, famiglia: "Alimentazione/Trasporto",
    idCategoriaMerceologica: 139, categoriaMerceologica: "Rulli Presa Carta",
    idMarca: 20, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 2, confezione: 1,
    richiedeAbbinamento: true, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.095, pesoNetto: 0.070, lunghezza: 11.0, larghezza: 6.0, altezza: 6.0,
    classeSconto: "KY-ROLL", dataInserimento: "2022-03-10", dataUltimaModifica: "2024-01-10",
  },
  {
    sku: "6LA27845000", brand: "TOSHIBA", category: "ricambi",
    title: "Rullo Fusore Superiore Toshiba",
    compatibility: "e-STUDIO 2006, 2007, 2306, 2307, 2506, 2507",
    type: "Compatibile", yield: "-", color: "-",
    dtkCodice: "4514944", idFamiglia: 2, famiglia: "Gruppi Fusore",
    idCategoriaMerceologica: 150, categoriaMerceologica: "Rulli Fusore",
    idMarca: 45, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: true, isKit: false, originale: false, pesante: true,
    pesoLordo: 1.320, pesoNetto: 1.120, lunghezza: 37.0, larghezza: 8.0, altezza: 8.0,
    classeSconto: "TOS-FUSER", dataInserimento: "2022-01-15", dataUltimaModifica: "2023-12-05",
  },
  {
    sku: "JC97-03132A", brand: "SAMSUNG", category: "ricambi",
    title: "Rullo Presa Carta Samsung",
    compatibility: "ML-2160, ML-2165, ML-2165W, ML-2168, SCX-3400, SCX-3405, SCX-3405F, SCX-3405W",
    type: "Compatibile", yield: "-", color: "-",
    dtkCodice: "5479144", idFamiglia: 1, famiglia: "Alimentazione/Trasporto",
    idCategoriaMerceologica: 139, categoriaMerceologica: "Rulli Presa Carta",
    idMarca: 38, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 2, confezione: 1,
    richiedeAbbinamento: true, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.080, pesoNetto: 0.055, lunghezza: 10.0, larghezza: 5.5, altezza: 5.5,
    classeSconto: "SAM-ROLL", dataInserimento: "2022-04-05", dataUltimaModifica: "2023-09-15",
  },
  {
    sku: "40X8024", brand: "LEXMARK", category: "ricambi",
    title: "Kit Rulli Alimentazione Lexmark",
    compatibility: "MS310d, MS310dn, MS312dn, MS410d, MS410dn, MS415dn, MS510dn, MS610dn, MS610dte",
    type: "Compatibile", yield: "-", color: "-",
    dtkCodice: "2197935", idFamiglia: 17, famiglia: "Kit Rulli Alimentazione",
    idCategoriaMerceologica: 117, categoriaMerceologica: "Rulli Alimentazione",
    idMarca: 22, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 8, unitaDiMisura: "SET",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: true, isKit: true, originale: false, pesante: false,
    pesoLordo: 0.380, pesoNetto: 0.280, lunghezza: 22.0, larghezza: 12.0, altezza: 8.0,
    classeSconto: "LEX-ROLL", dataInserimento: "2022-03-20", dataUltimaModifica: "2023-11-10",
  },
  {
    sku: "126K29404", brand: "XEROX", category: "ricambi",
    title: "Unità Fusore Xerox",
    compatibility: "Phaser 6510, Phaser 6510DN, WorkCentre 6515, WC 6515DN, VersaLink C500, C505",
    type: "Compatibile", yield: "-", color: "-",
    dtkCodice: "3871230", idFamiglia: 15, famiglia: "Fusori Completi",
    idCategoriaMerceologica: 116, categoriaMerceologica: "Ricambi Fusore",
    idMarca: 49, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: true, isKit: false, originale: false, pesante: true,
    pesoLordo: 2.850, pesoNetto: 2.400, lunghezza: 38.0, larghezza: 15.0, altezza: 18.0,
    classeSconto: "XER-FUSER", dataInserimento: "2022-02-15", dataUltimaModifica: "2024-03-05",
  },

  // ============ KIT ============

  {
    sku: "KIT-TN247", brand: "BROTHER", category: "toner",
    title: "Kit Completo Brother TN-247 CMYK (4 Toner)",
    compatibility: "HL-L3210CW, HL-L3230CDW, MFC-L3710CW, MFC-L3770CDW",
    type: "Kit", yield: "3.000/2.300 pagine", color: "Set CMYK",
    dtkCodice: "9961380", idFamiglia: 9, famiglia: "Kit Manutenzione",
    idCategoriaMerceologica: 120, categoriaMerceologica: "Kit Manutenzione Completo",
    idMarca: 3, idColore: 5, coloreDescrizione: "Set CMYK",
    idUdm: 2, unitaDiMisura: "KIT",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: true, originale: false, pesante: false,
    pesoLordo: 2.650, pesoNetto: 2.100, lunghezza: 32.0, larghezza: 15.0, altezza: 15.0,
    classeSconto: "BR247KIT", dataInserimento: "2022-04-01", dataUltimaModifica: "2024-01-15",
    idTipologiaNovita: 2, novita: "In Promozione", dataScadenzaNovita: "2024-03-31",
  },
  {
    sku: "KIT-W2030", brand: "HP", category: "toner",
    title: "Kit Completo HP 415A CMYK (4 Toner)",
    compatibility: "Color LaserJet Pro M454dw, M454dn, MFP M479dw, M479fdn, M479fdw",
    type: "Kit", yield: "2.400/2.100 pagine", color: "Set CMYK",
    dtkCodice: "5107245", idFamiglia: 9, famiglia: "Kit Manutenzione",
    idCategoriaMerceologica: 120, categoriaMerceologica: "Kit Manutenzione Completo",
    idMarca: 15, idColore: 5, coloreDescrizione: "Set CMYK",
    idUdm: 2, unitaDiMisura: "KIT",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: true, originale: false, pesante: false,
    pesoLordo: 3.000, pesoNetto: 2.400, lunghezza: 30.0, larghezza: 14.0, altezza: 16.0,
    classeSconto: "HP415KIT", dataInserimento: "2022-04-01", dataUltimaModifica: "2024-03-10",
    idTipologiaNovita: 2, novita: "In Promozione", dataScadenzaNovita: "2024-03-31",
  },
  {
    sku: "KIT-TK5240", brand: "KYOCERA MITA", category: "toner",
    title: "Kit Kyocera TK-5240 CMYK (4 Toner)",
    compatibility: "ECOSYS M5526cdn, M5526cdw, P5026cdn, P5026cdw",
    type: "Kit", yield: "4.000/3.000 pagine", color: "Set CMYK",
    dtkCodice: "3741438", idFamiglia: 9, famiglia: "Kit Manutenzione",
    idCategoriaMerceologica: 120, categoriaMerceologica: "Kit Manutenzione Completo",
    idMarca: 20, idColore: 5, coloreDescrizione: "Set CMYK",
    idUdm: 2, unitaDiMisura: "KIT",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: true, originale: false, pesante: false,
    pesoLordo: 3.200, pesoNetto: 2.600, lunghezza: 32.0, larghezza: 14.0, altezza: 16.0,
    classeSconto: "KY5240KIT", dataInserimento: "2022-06-01", dataUltimaModifica: "2024-02-15",
  },
  {
    sku: "KIT-HP-M404", brand: "HP", category: "toner",
    title: "Kit Manutenzione HP LaserJet M404 (Toner + Tamburo)",
    compatibility: "LaserJet Pro M304a, M404d, M404dn, M404dw, MFP M428dw, M428fdn, M428fdw",
    type: "Kit", yield: "Toner 3.000p + Tamburo 23.000p", color: "-",
    dtkCodice: "8755439", idFamiglia: 9, famiglia: "Kit Manutenzione",
    idCategoriaMerceologica: 120, categoriaMerceologica: "Kit Manutenzione Completo",
    idMarca: 15, idColore: 0, coloreDescrizione: "N/D",
    idUdm: 2, unitaDiMisura: "KIT",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: true, originale: false, pesante: false,
    pesoLordo: 1.780, pesoNetto: 1.460, lunghezza: 32.0, larghezza: 14.0, altezza: 14.5,
    classeSconto: "HP-M404KIT", dataInserimento: "2023-01-15", dataUltimaModifica: "2024-03-10",
    idTipologiaNovita: 1, novita: "Nuovo Arrivo", dataScadenzaNovita: "2024-06-30",
  },

  // ============ TONER PER MODELLI 1022 ============
  // (ora in mockProductsCanonIR1022.ts)

  {
    sku: "Q2612A", brand: "HP", category: "toner",
    title: "Toner Compatibile HP 12A Q2612A",
    compatibility: "LaserJet 1010, LaserJet 1012, LaserJet 1015, LaserJet 1018, LaserJet 1020, LaserJet 1022, LaserJet 1022N, LaserJet 1022NW, LaserJet 3015, LaserJet 3020, LaserJet 3030, LaserJet 3050, LaserJet 3052, LaserJet 3055, LaserJet M1005, LaserJet M1319",
    type: "Compatibile", yield: "2.000 pagine", color: "Nero",
    dtkCodice: "7366205", idFamiglia: 5, famiglia: "Toner Laser Mono",
    idCategoriaMerceologica: 114, categoriaMerceologica: "Toner Laser Mono",
    idMarca: 15, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.580, pesoNetto: 0.460, lunghezza: 28.0, larghezza: 10.0, altezza: 8.5,
    classeSconto: "HP-Q2612", dataInserimento: "2018-03-20", dataUltimaModifica: "2024-01-15",
  },
  {
    sku: "TYPE-1220D", brand: "RICOH", category: "toner",
    title: "Toner Compatibile Ricoh Type 1220D",
    compatibility: "Aficio 1015, Aficio 1018, Aficio 1022, Aficio 1027, Aficio 1032",
    type: "Compatibile", yield: "9.000 pagine", color: "Nero",
    dtkCodice: "5528972", idFamiglia: 5, famiglia: "Toner Copiatrice",
    idCategoriaMerceologica: 115, categoriaMerceologica: "Toner Copiatrice B/N",
    idMarca: 28, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: true, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.950, pesoNetto: 0.780, lunghezza: 36.0, larghezza: 8.0, altezza: 8.0,
    classeSconto: "RIC-1220D", dataInserimento: "2018-06-15", dataUltimaModifica: "2024-01-15",
  },
  {
    sku: "TK-18", brand: "KYOCERA MITA", category: "toner",
    title: "Toner Compatibile Kyocera TK-18",
    compatibility: "FS-1018MFP, FS-1020D, FS-1022MFP, FS-1118MFP",
    type: "Compatibile", yield: "7.200 pagine", color: "Nero",
    dtkCodice: "4684531", idFamiglia: 5, famiglia: "Toner Laser Mono",
    idCategoriaMerceologica: 114, categoriaMerceologica: "Toner Laser Mono",
    idMarca: 19, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.680, pesoNetto: 0.540, lunghezza: 30.0, larghezza: 9.0, altezza: 9.0,
    classeSconto: "KYO-TK18", dataInserimento: "2018-06-15", dataUltimaModifica: "2024-01-15",
  },
  {
    sku: "T-1022", brand: "TOSHIBA", category: "laser-inkjet",
    title: "Cartuccia Compatibile Toshiba MJ-1022",
    compatibility: "MJ-1022",
    type: "Compatibile", yield: "800 pagine", color: "Nero",
    dtkCodice: "6440561", idFamiglia: 7, famiglia: "Cartucce Inkjet",
    idCategoriaMerceologica: 112, categoriaMerceologica: "Cartucce Inkjet",
    idMarca: 33, idColore: 1, coloreDescrizione: "Nero",
    idUdm: 6, unitaDiMisura: "PZ.",
    minimoVendibile: 1, confezione: 1,
    richiedeAbbinamento: false, isKit: false, originale: false, pesante: false,
    pesoLordo: 0.120, pesoNetto: 0.080, lunghezza: 12.0, larghezza: 5.0, altezza: 4.0,
    classeSconto: "TOS-1022", dataInserimento: "2019-03-10", dataUltimaModifica: "2024-01-15",
  },

  // ============ BROTHER + RICOH (325 prodotti) ============
  ...ALL_BROTHER_RICOH_PRODUCTS,

  // ============ CANON iR 1022 / iR C1022 e linee collegate ============
  ...ALL_CANON_IR1022_PRODUCTS,
];

export const CONTACT_INFO: ContactInfo = {
  address: "Via Acuto 52/b, 00131 Roma",
  phone: "+39 06 5135753",
  fax: "+39 06 5030894",
  hours: "Lun - Ven: 9:00 - 19:00",
  emails: [
    { dept: "Informazioni", email: "info@dtksrl.eu" },
    { dept: "Commerciale", email: "commerciale@dtksrl.eu" },
    { dept: "Amministrazione", email: "amministrazione@dtksrl.eu" },
    { dept: "Acquisti", email: "fornitori@dtksrl.eu" },
    { dept: "Magazzino/Spedizioni", email: "magazzino@dtksrl.eu" }
  ],
  iban: "IT 19 G 02008 05198 000102277024",
  bank: "Unicredit AG. 242"
};

export const VALUE_PROPS: ValueProp[] = [
  { icon: "Package", title: "8.000+ Articoli", desc: "Sempre disponibili a magazzino" },
  { icon: "ShoppingCart", title: "Nessun Minimo", desc: "Ordina anche un solo pezzo" },
  { icon: "Truck", title: "Spedizione 24H", desc: "In tutta Italia, entro il giorno successivo" },
  { icon: "Headphones", title: "Assistenza Dedicata", desc: "Supporto tecnico e commerciale" }
];
